import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { StateCitiesInModalType } from '../types';
import { REDUCER_CITIES_IN_MODAL_NAME } from '../constants';

const initialState: StateCitiesInModalType = {
  isVisible: false,
  isLoaded: false,
  isLoadInProcess: false,
};

const sliceCitiesInModal = createSlice({
  name: REDUCER_CITIES_IN_MODAL_NAME,
  initialState,
  reducers: {
    open: (state) => {
      state.isVisible = true;
    },
    hide: (state) => {
      state.isVisible = false;
    },
    setIsLoaded: (state, action: PayloadAction<boolean>) => {
      state.isLoaded = action.payload;
    },
    setIsLoadInProcess: (state, action: PayloadAction<boolean>) => {
      state.isLoadInProcess = action.payload;
    },
  },
});

const reducerCitiesInModal = sliceCitiesInModal.reducer;

const {
  open: citiesInModalOpen,
  hide: citiesInModalHide,
  setIsLoaded: citiesInModalSetIsLoaded,
  setIsLoadInProcess: citiesInModalSetIsLoadInProcess,
} = sliceCitiesInModal.actions;

export {
  reducerCitiesInModal,
  citiesInModalOpen,
  citiesInModalHide,
  citiesInModalSetIsLoaded,
  citiesInModalSetIsLoadInProcess,
};
